import urlRegex from './url-regex';

/**
 * 判断链接是否合法
 */
export function isValidUrl(targetUrl, allowSharp) {
	return urlRegex({ exact: true, strict: false, allowSharp }).test(targetUrl);
}



// WEBPACK FOOTER //
// ./lib/helpers/isValidUrl.js